module.exports = __webpack_public_path__ + "img/capusta-manifest.da2ed434.png";